module.exports = __webpack_public_path__ + "static/kartchen-mobilitat3-acc0cc9ff52e18126d9564501bdd2ad2.png";